import { PRODUCT_TYPES, SUPPORTED_UNITS } from '@schuettflix/interfaces';

export const productTypeToUnitMap = {
    // =================================
    // Handled by custom-request-service
    // =================================
    // Materials
    CUSTOM_BULK_MATERIAL: 'TON',
    CUSTOM_RECYCLED_BULK_MATERIAL: 'TON',
    CUSTOM_CONCRETE: 'TON',
    CUSTOM_ASPHALT: 'TON',
    // Waste
    CUSTOM_HAZARDOUS_WASTE_DISPOSAL: 'TON',
    CUSTOM_HAZARDOUS_WASTE_RECYCLING: 'TON',
    CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL: 'TON',
    CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING: 'TON',
    // Transports
    CUSTOM_TRANSPORT: undefined,
    // Material Services
    CUSTOM_SERVICE: 'TON',
    CUSTOM_SERVICE_ANALYSIS: 'PIECE',
    CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT: 'PIECE',
    // Transport Services
    CUSTOM_SERVICE_TRANSPORT: 'TON',
    CUSTOM_SERVICE_TOLL: 'PIECE',
    CUSTOM_SERVICE_WAITING_TIME: 'HOUR',
    // ===================================
    // Handled by material-channel-service
    // ===================================
    // Materials
    BULK_MATERIAL: 'TON',
    RECYCLED_BULK_MATERIAL: 'TON',
    // Waste
    HAZARDOUS_WASTE_DISPOSAL: 'TON',
    HAZARDOUS_WASTE_RECYCLING: 'TON',
    NON_HAZARDOUS_WASTE_DISPOSAL: 'TON',
    NON_HAZARDOUS_WASTE_RECYCLING: 'TON',
    // ============================
    // Handled by transport-service
    // ============================
    TRANSPORT: undefined,
    // ============================
    // Not Handled by any channel
    // ============================
    SERVICE_TOLL: 'PIECE',
    SERVICE_WEIGHING_NOTE: 'PIECE',
    SERVICE_ACCOMPANYING_DOCUMENT: 'PIECE',
    SERVICE_ENERGY_SURCHARGE: 'PIECE',
} as const satisfies Record<PRODUCT_TYPES, SUPPORTED_UNITS | undefined>;
